import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.7 9.89L7.82 6l3.89-3.89A.996.996 0 1010.3.7L5.71 5.29a.996.996 0 000 1.41l4.59 4.59c.39.39 1.02.39 1.41 0a.993.993 0 00-.01-1.4zM1 0c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V1c0-.55.45-1 1-1z" fill="#444" /></svg>;